// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2QAvS","row":"Node_row__1H56l","label":"Node_label__1LqvT","footer":"Node_footer__2RouT"};